import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { useNavigate } from "react-router-dom";
import './ModalPaymentConfirmation.scss'
import { TextPage } from "../../TextPage/TextPage";
import usePushStore from "../../../store/toast";
import { ModalComponent } from "../ModalComponent/ModalComponent";

// Пример ответа
// {
//     "detail": {
//         "code": "confirmation_required",
//         "message": "Закончился лимит на услуги сервиса",
//         "service_name": "Обобщение отзывов по товарам, брендам и категориям",
//         "payment_cost": 100.0,
//         "balance": 49947.669462
//     }
// }

// const data = {
//     "code": "confirmation_required",
//     "message": "Закончился лимит на услуги сервиса",
//     "service_name": "Обобщение отзывов по товарам, брендам и категориям",
//     "payment_cost": 100.0,
//     "balance": 49947.669462
// }

const ModalPaymentConfirmation = ({
    setIsModal,
    answerData,
    setStatusPayment
}) => {

    const navigate = useNavigate();
    const addPush = usePushStore((state) => state.addPush);

    const addPushTooltip = (text = '', type = 'success') => {
        addPush({
            type: type,
            title: 'Информация',
            message: text,
            timeout: 10000,
        });
    }

    return (
        <ModalComponent
            onClose={() => setIsModal(false)}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-confirm-ignore-tnved'>
                    <TextPage
                        text={<>{answerData?.message}: <br />
                            <span style={{ color: '#1890FF', fontWeight: 700 }}>"{answerData?.service_name}"</span></>}
                    />

                    <TextPage
                        text={<>Для дальнейшего использования сервиса нужно подтвердить оплату:
                            <br /><br />
                            Стоимость: <span style={{ color: '#51ca64', fontWeight: 700 }}> {answerData?.payment_cost?.toLocaleString()}</span> руб.<br />
                            Баланс: <span style={{ color: '#51ca64', fontWeight: 700 }}> {answerData?.balance?.toLocaleString()}</span> руб.</>
                        }
                    />
                    <div className='modal-confirm-ignore-tnved__group-btn'>
                        {answerData?.code === "confirmation_required" && <ButtonBasic
                            blue
                            text={`Подтвердить оплату ${answerData?.payment_cost?.toLocaleString()} руб.`}
                            width='100%'
                            onClick={(e) => {
                                setStatusPayment(true)
                                addPushTooltip('Оплата прошла успешно')
                                setIsModal(false)
                            }}
                        />}

                        {answerData?.code === "balance_conflict" && <ButtonBasic
                            blue
                            text={`Пополнить баланс`}
                            width='100%'
                            onClick={(e) => {
                                navigate('/settings/payment')
                                setIsModal(false)
                            }}
                        />}

                        <ButtonBasic
                            grey
                            text='Отмена'
                            width='100%'
                            onClick={(e) => {
                                setIsModal(false)
                            }}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalPaymentConfirmation }